import classNames from 'classnames';
import { ReactNode, useCallback } from 'react';
import { Button, ButtonProps, attempt } from 'yoso';
import { AccordionContextValue, useAccordion } from '~/components/Accordion/v2/Accordion.hooks';
import { Chevron } from '~/components/Icon/Chevron';
import styles from './AccordionButton.module.scss';

export type AccordionButtonProps = Omit<ButtonProps, 'children'> & {
  icon?: ReactNode | ((value: AccordionContextValue) => ReactNode);
  children?: ReactNode | ((value: AccordionContextValue) => ReactNode);
};
export const AccordionButton = ({
  className,
  icon = <Chevron className={styles.icon} />,
  block = true,
  onClick,
  children,
  ...props
}: AccordionButtonProps) => {
  const context = useAccordion();
  const { active, setActive } = context;
  const handleClick = useCallback(
    (e) => {
      onClick?.(e);
      if (!e.defaultPrevented) {
        setActive((active) => !active);
      }
    },
    [onClick, setActive]
  );
  return (
    <Button
      className={classNames(styles.root, { [styles.active]: active }, className)}
      block={block}
      onClick={handleClick}
      {...props}>
      {attempt(children, context)}
      {attempt(icon, context)}
    </Button>
  );
};
